<!-- 
 @fileoverview This is the Filter popup template 
 @author Harish Kumaran
 @created June, 2024
 -->
 <div class="heading">
    <h5>Select filter</h5>
</div>
<div mat-dialog-content>
    <mat-checkbox [(ngModel)]="isSelectAllChecked" (change)="toggleSelectAll($event)">
        Select All
    </mat-checkbox>
    <div class="checkbox-container">
        <ng-container *ngFor="let value of columnData; let i = index">
            <mat-checkbox [checked]="selectedValues[i]" (change)="toggleSelection(i)">
            {{value}}
            </mat-checkbox>
        </ng-container>
    </div>
</div>
<div mat-dialog-actions class="dialog-actions-container">
    <div class="cancel">
        <button class="btn btn-dark btn-sm" (click)="onCancel()"><label for="cancel">Cancel</label></button> 
    </div>
    <div class="apply">
        <button class="btn btn-dark btn-sm" (click)="applyFilter()" [disabled]="isApplyDisabled"><label for="apply">Apply</label></button>
    </div>    
</div>